export default __webpack_public_path__ + "static/media/file-20-px-blue.78d314c0.svg";